import {Fragment} from 'react';
import {Helmet} from 'react-helmet';
import PropTypes from 'prop-types';
import Config from '../../../config';
import Box from '@material-ui/core/Box';

const Page = ({children, title, padding = 3, customStyle, ...rest}) => {
  return (
    <Fragment>
      <div {...rest}>
        <Helmet>
          <title>{`${title} | ${Config.appName}`}</title>
        </Helmet>
        <Box className="page_content" padding={padding} style={customStyle !== undefined ? customStyle : null}>{children}</Box>
      </div>
    </Fragment>
  );
};

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
};

Page.defaultProps = {
  title: '',
};

export default Page;
